module.exports = __webpack_public_path__ + "static/media/img_15.4b97c05b.png";